import { render, staticRenderFns } from "./UiMenuMobile.vue?vue&type=template&id=f8c83e12&scoped=true"
import script from "./UiMenuMobile.vue?vue&type=script&lang=js"
export * from "./UiMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./UiMenuMobile.vue?vue&type=style&index=0&id=f8c83e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c83e12",
  null
  
)

export default component.exports